/* eslint-disable react-hooks/exhaustive-deps */
import {
  ContainerRow,
  DesktopContainer,
  MobileContainer,
} from "../../../../components/Container";
import ExcelJS from "exceljs";
import { dateFormat } from "../../../../utils/helper";
import { useApp } from "../../../../contexts";
import { useEffect, useCallback, useState } from "react";
import { FilterRow, FilterRow2, FilterRowItem, FilterRowItem2 } from "./styles";
import { FormButton, FormItem, FormSelect } from "../../../../components/Form";
import FormButton2 from "../../../../components/FormCustom2/Button";
import FormInput from "../../../../components/FormCustom2/Input";
import { Col, Form, Row } from "antd";
import {
  CellRowImage,
  CellRowValue,
  EqualIcon2,
} from "../../../wallet-list/styles";
import {
  CellStatus,
  ContainerTable,
  paginationRender,
  PaginationView,
  TableView,
} from "../../../../components/Table";
import {
  formatCurrency,
  getTransactionList,
  roundNumber,
  statusConvert,
  typeConvert,
} from "../../../../services/app";
import moment from "moment";
import Detail from "./detail";
import produce from "immer";
import {
  Alert,
  AlertBg,
  AlertContent,
  AlertText,
  ErrorIcon,
  SuccessIcon,
} from "../../../withdraw/styles";
import { Copy } from "../../../../components/Copy";
import { DatePickerView } from "../../../../components/DatePicker";
import { useParams, useSearchParams } from "react-router-dom";
import { FilterMbIcon } from "../../../../components/Icons/FilterMbIcon";
import { CopyIcon } from "../../../../components/Icons/CopyIcon";
import { WithDrawIcon } from "../../../../components/Icons/WithDrawIcon";
import { DepositIcon } from "../../../../components/Icons/DepositIcon";
import { TransferIcon } from "../../../../components/Icons/TransferIcon";
import {
  StatusSort,
  statusFilterTransaction1,
  statusFilterTransaction2,
  typeTransactionOptions,
} from "../../../../constants";
import ModalFilter from "./ModalFilter";
import EmptyTable from "../../../../components/EmptyTable";
import EmptyTableMobile from "../../../../components/EmptyTableMobile";
import { getCoinCodeImage } from "../../../../utils/helper";
import TransactionItem2 from "./TransactionItem2";

export const getValueByTab = (tab, values) => {
  return values[0];
};

export default function TransactionHistory(props) {
  const {
    T,
    formatLocalCurrency,
    getCurrency,
    convertToBTC,
    convertToLocalCurrency,
    setLoading,
    loading,
    currencies,
    convertToCurrency,
    language,
    user,
  } = useApp();
  const [searchParams] = useSearchParams();
  let { type, code, transactionId } = {
    type: searchParams.get("type"),
    code: searchParams.get("code"),
    transactionId: searchParams.get("transactionId"),
    ...(useParams() || {}),
  };

  const [tab, setTab] = useState(getValueByTab(type, ["crypto"]));
  const [alert, setAlert] = useState("");
  const [datePicker, setDatePicker] = useState(false);
  const [sortBTC, setSortBTC] = useState(StatusSort.none);
  const [isOpenModalFilter, setIsOpenModalFilter] = useState(false);
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);

  const onCell = (record, rowIndex) => {
    return {
      onClick: (event) => {
        if (
          event.target.classList.contains("copy") ||
          event.target.tagName === "svg" ||
          event.target.tagName === "path"
        ) {
          return;
        }
        if (
          record.from_currency_code === "USD" ||
          record.from_currency_code === "JPY"
        )
          return;
        setRow(record);
      },
    };
  };

  const initQuery = () => {
    return getValueByTab(tab, [
      {
        crypto: {
          currencyCode: null,
          fromCurrencyCode: null,
          date: null,
          transactionType: null,
          transactionStatus: null,
        },
      },
    ]);
  };
  const [query, setQuery] = useState(initQuery());
  const [querySubmit, setQuerySubmit] = useState(initQuery());
  const [convertValue, setConvertValue] = useState([]);
  const [row, setRow] = useState();
  const [form] = Form.useForm();

  const toggleModalFilter = () => {
    setIsOpenModalFilter((prev) => !prev);
  };
  const getIconType = (type) => {
    switch (type) {
      case "withdraw":
      case "checkout":
        return <WithDrawIcon />;
      case "deposit":
        return <DepositIcon />;
      case "transfer":
        return <TransferIcon />;
      default:
        return <TransferIcon />;
    }
  };

  const columns = [
    {
      title: T("Transaction ID"),
      dataIndex: "code",
      key: "code",
      onCell: onCell,
      render: (text, record, index) => {
        return (
          <div className="w-[150px]">
            <Copy
              textStyle={{ fontWeight: 400, fontSize: 16 }}
              cutText={true}
              splitFont={5}
              numDot={3}
              text={text}
              icon={<CopyIcon />}
            />
          </div>
        );
      },
    },
    ...getValueByTab(tab, [
      [
        {
          title: T("From Currency"),
          dataIndex: "coinFrom",
          key: "coinFrom",
          onCell: onCell,
          render: (text, record, index) => {
            return text ? (
              <CellRowImage className="v2">
                <img
                  alt=""
                  style={{ width: 28, height: 28 }}
                  src={`/assets/images/otc/crypto/${getCoinCodeImage(
                    text?.toLowerCase() || ""
                  )}.svg`}
                />
                <div>
                  <span style={{ fontSize: 15, fontWeight: 400 }}>{text}</span>
                  <br />
                  <span style={{ fontSize: 16, fontWeight: 600 }}>
                    {formatCurrency(record?.amount, null, getCurrency())}
                  </span>
                </div>
              </CellRowImage>
            ) : null;
          },
        },
        {
          title: T("To Currency"),
          dataIndex: "coin",
          key: "coin",
          onCell: onCell,
          render: (text, record, index) => {
            return text ? (
              <CellRowImage className="v2">
                <img
                  alt=""
                  style={{ width: 28, height: 28 }}
                  src={`/assets/images/otc/crypto/${getCoinCodeImage(
                    text
                  )?.toLowerCase()}.svg`}
                />
                <div>
                  <span style={{ fontSize: 15, fontWeight: 400 }}>{text}</span>
                  <br />
                  <span style={{ fontSize: 16, fontWeight: 600 }}>
                    {formatCurrency(record?.toAmount, null, getCurrency())}
                  </span>
                </div>
              </CellRowImage>
            ) : null;
          },
        },
      ],
      [
        {
          title: T("Type"),
          dataIndex: "type",
          key: "type",
          onCell: onCell,
          render: (text, record, index) => {
            const val = text.split(" ").join("_");
            return (
              <div className="flex items-center gap-[6px]">
                <span> {getIconType(val)}</span>
                <span className="text-[#000000] font-normal text-[16px] leading-[25px] capitalize">
                  {T(text)}
                </span>
              </div>
            );
          },
        },
        {
          title: T("Amount"),
          dataIndex: "amount",
          key: "amount",
          align: "right",
          onCell: onCell,
          render: (text, record, index) => {
            return (
              <span className="text-[16px]">
                {formatCurrency(text, null, getCurrency())}
              </span>
            );
          },
        },
      ],
    ]),

    {
      title: T("BTC Value"),
      dataIndex: "btc",
      align: "right",
      className: "btc-value",
      key: "btc",
      sorter: (a, b) => parseFloat(a.btc) - parseFloat(b.btc),
      onCell: onCell,
      render: (text, record, index) => {
        return (
          <CellRowValue>
            <div className="flex flex-col gap-1 items-end">
              <p className="text-[16px] font-normal">
                {formatCurrency(text, null, getCurrency())}
              </p>
              <span>
                <EqualIcon2 />
                <span
                  style={{
                    fontSize: 14,
                    color: "#818181",
                    fontWeight: 400,
                    marginLeft: 7,
                  }}
                >
                  {formatLocalCurrency(record.local)}
                </span>
              </span>
            </div>
          </CellRowValue>
        );
      },
    },
    {
      title: T("Status"),
      dataIndex: "status",
      key: "status",
      onCell: onCell,
      render: (text, record, index) => {
        return <CellStatus text={text}>{T(text)}</CellStatus>;
      },
    },
    {
      title: T("Time"),
      dataIndex: "time",
      key: "time",
      align: "center",
      className: "text-center",
      onCell: onCell,
      sorter: (a, b) =>
        moment(a.time, "YYYY/MM/DD HH:mm:sss").toDate().getTime() -
        moment(b.time, "YYYY/MM/DD HH:mm:sss").toDate().getTime(),
      render: (val) => (
        <span style={{ color: "#818181", fontSize: 16, fontWeight: 400 }}>
          {val}
        </span>
      ),
    },
  ];

  const handleTableChange = (pagination, filters, sorter) => {
    const { field, order } = sorter;
    if (field === "btc") {
      setSortBTC(order);
    }
  };

  useEffect(() => {
    if (transactionId) {
      setRow({ id: transactionId });
    }
  }, [transactionId]);

  useEffect(() => {
    loadData().then();
  }, [page, querySubmit, tab]);

  useEffect(() => {
    let timer;
    if (alert) {
      timer = setTimeout(() => setAlert(""), 2000);
    }
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [alert]);

  const convertData = useCallback(() => {
    return rows.map((item) => {
      let status = statusConvert(item);
      let itemType = typeConvert(item);
      const convertCode =
        item?.type === 1 ||
        item?.type === 5 ||
        item?.type === 7 ||
        item?.type === 6
          ? item.dest_currency_code
          : item.from_currency_code;
      return {
        ...item,
        local: convertToLocalCurrency(item.amount, convertCode, getCurrency()),
        id: item.id,
        transactionId: item.id,
        type: itemType,
        coin: item.dest_currency_code,
        coinFrom: item.from_currency_code,
        toAmount:
          item.from_currency_code && item.from_currency_code
            ? convertToCurrency(
                item.amount,
                item.from_currency_code,
                item.dest_currency_code,
                getCurrency()
              )
            : item.amount,
        amount: item.amount,
        btc: convertToBTC(item.amount, convertCode, getCurrency()),
        status: status,
        time: moment(item.created_time).format("YYYY/MM/DD HH:mm:ss"),
      };
    });
  }, [
    convertToBTC,
    convertToCurrency,
    convertToLocalCurrency,
    getCurrency,
    rows,
  ]);

  const loadData = async () => {
    setLoading(true);
    const data = getValueByTab(tab, [querySubmit.crypto]);
    let result = await getTransactionList({
      page: page,
      size: 15,
      ...data,
      ...getValueByTab(tab, [{}, {}, {}]),
    });
    if (result.status === 200) {
      const data = result?.data?.data?.transactions?.rows || [];
      setTotal(result?.data?.data?.transactions?.count || 0);
      setRows(data);
    }
    setLoading(false);
  };
  const loadDataExport = async () => {
    let exportPage = 1;
    let dataExport = [];
    while (true) {
      const data = getValueByTab(tab, [querySubmit.crypto]);
      const result = await getTransactionList({
        page: exportPage,
        size: 500,
        ...data,
        ...getValueByTab(tab, [{}, {}, {}]),
      });
      if (result.status === 200) {
        const res = result?.data?.data?.transactions?.rows || [];
        dataExport = [...dataExport, ...res];
        exportPage += 1;
        if (result?.data?.data?.transactions?.rows.length < 500) break;
      }
    }
    return dataExport;
  };
  const handleExport = async () => {
    try {
      if (loading) return;
      setLoading(true);

      const cashflowData = await loadDataExport();

      const workbook = new ExcelJS.Workbook();

      const worksheet = workbook.addWorksheet("Data");

      const columns = [
        { key: "user_id", header: T("User Id") },
        { key: "user_email", header: T("Email") },
        { key: "user_name", header: T("Display name") },
        { key: "transaction_code", header: T("Transaction ID") },
        { key: "wallet_address_from", header: T("From Address") },
        { key: "wallet_address_to", header: T("To Address") },
        { key: "wallet_address", header: T("From Currency") },
        { key: "to_address", header: T("To Currency") },
        { key: "local_value", header: T("Value") },
        { key: "fee_amount", header: T("Fee") },
        { key: "status", header: T("Status") },
        { key: "time", header: T("Time") },
      ];

      worksheet.columns = columns;
      cashflowData.forEach((cashflow) => {
        let status = statusConvert(cashflow);
        const convertCode =
          cashflow?.type === 1 ||
          cashflow?.type === 5 ||
          cashflow?.type === 7 ||
          cashflow?.type === 6
            ? cashflow.dest_currency_code
            : cashflow.from_currency_code;

        let feeAmountText = "0";
        if (cashflow.from_currency_code === "ETH") {
          feeAmountText = `${formatCurrency(
            cashflow.fee_amount,
            null,
            getCurrency()
          )} ${cashflow.dest_currency_code || cashflow.from_currency_code}`;
        } else if (
          cashflow?.from_currency_code &&
          cashflow?.from_currency_code?.toString()?.toLowerCase() !== "sotd"
        ) {
          feeAmountText = `${formatCurrency(
            cashflow.fee_amount,
            null,
            getCurrency()
          )} ${cashflow.from_currency_code}`;
        }
        const data = [
          user.id,
          user.email,
          user.name,
          `"${cashflow.code}"`,
          cashflow.from_wallet_address,
          cashflow.dest_wallet_address,
          cashflow.from_currency_code
            ? formatCurrency(cashflow.amount, null, getCurrency()) +
              cashflow.from_currency_code
            : "",
          cashflow.dest_currency_code
            ? formatCurrency(
                cashflow.from_currency_code && cashflow.dest_currency_code
                  ? convertToCurrency(
                      cashflow.amount,
                      cashflow.from_currency_code,
                      cashflow.dest_currency_code,
                      getCurrency()
                    )
                  : cashflow.amount,
                null,
                getCurrency()
              ) + cashflow.dest_currency_code
            : "",
          formatLocalCurrency(
            convertToLocalCurrency(cashflow.amount, convertCode, getCurrency())
          ),
          feeAmountText,
          T(status),
          moment(
            code !== "SZT" ? cashflow.created_time : cashflow.createTime
          ).format("YYYY/MM/DD HH:mm:ss"),
        ];
        worksheet.addRow(data);
      });

      const csvData = await workbook.csv.writeBuffer();
      const blob = new Blob([new Uint8Array([0xef, 0xbb, 0xbf]), csvData], {
        type: "text/csv;charset=utf-8",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.setAttribute("charset", "utf-8");

      a.download = `transaction-${dateFormat(
        new Date(),
        "yyyy-MM-ddHH:mm:ss"
      )}.csv`;
      a.click();
      a.remove();
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const onSearch = (reset = false) => {
    setLoading(true);
    if (reset) {
      setQuerySubmit(initQuery());
    } else {
      setQuerySubmit(JSON.parse(JSON.stringify(query)));
    }
    setIsOpenModalFilter(false);
  };

  const handleReset = () => {
    setQuery(initQuery());
    onSearch(true);
    setIsOpenModalFilter(false);
  };

  const handleChangeTime = (value) => {
    setQuery(
      produce((draft) => {
        if (value !== "customized") {
          draft[fieldTabName].date = value;
        }
        switch (value) {
          case "7days": {
            draft[fieldTabName].fromDate = moment()
              .startOf("day")
              .subtract(7, "days")
              .toDate()
              .getTime();
            draft[fieldTabName].toDate = moment()
              .endOf("day")
              .toDate()
              .getTime();
            break;
          }
          case "30days": {
            draft[fieldTabName].fromDate = moment()
              .startOf("day")
              .subtract(30, "days")
              .toDate()
              .getTime();
            draft[fieldTabName].toDate = moment()
              .endOf("day")
              .toDate()
              .getTime();
            break;
          }
          case "60days": {
            draft[fieldTabName].fromDate = moment()
              .startOf("day")
              .subtract(60, "days")
              .toDate()
              .getTime();
            draft[fieldTabName].toDate = moment()
              .endOf("day")
              .toDate()
              .getTime();
            break;
          }
          case "customized": {
            setDatePicker(true);
            break;
          }
          default: {
            draft[fieldTabName].fromDate = undefined;
            draft[fieldTabName].toDate = undefined;
          }
        }
      })
    );
  };

  const values = convertValue || [];
  const fieldTabName = getValueByTab(tab, ["crypto"]);
  const queryTabValue = getValueByTab(tab, [query?.crypto]);

  const handleSort = (e) => {
    e.stopPropagation();
    if (!sortBTC) {
      setSortBTC(StatusSort.descend);
    }
    if (sortBTC === StatusSort.descend) {
      setSortBTC(StatusSort.ascend);
    }
    if (sortBTC === StatusSort.ascend) {
      setSortBTC(StatusSort.none);
    }
  };

  const renderItemMobile = () => {
    let isSorted = false;
    const valueClone = [...values];
    const valueSorted = valueClone?.sort((a, b) => {
      if (sortBTC === StatusSort.ascend) {
        isSorted = true;
        return b.btc - a.btc;
      }
      if (sortBTC === StatusSort.descend) {
        isSorted = true;
        return a.btc - b.btc;
      }
      return null;
    });

    return (
      <Row gutter={[0, 20]}>
        {values?.length ? (
          (isSorted ? valueSorted : values)?.map((item) => (
            <Col key={item.id} span={24} onClick={() => setRow(item)}>
              <TransactionItem2
                handleSort={handleSort}
                sorted={sortBTC}
                version={2}
                item={item}
              />
            </Col>
          ))
        ) : (
          <div className="w-full flex justify-center pt-[10px]">
            <EmptyTableMobile T={T} />
          </div>
        )}
      </Row>
    );
  };

  useEffect(() => {
    setConvertValue(convertData);
  }, [convertData, rows]);

  return (
    <div>
      <div>
        <MobileContainer>
          <div className="relative my-[10px] flex items-center justify-between">
            <div
              className="lg:hidden flex h-[35px] items-center justify-center rounded-3xl gap-[8px] bg-white w-[100px]"
              onClick={toggleModalFilter}
            >
              <FilterMbIcon />
              <span className="text-[14px] leading-[26px] text-[#000]">
                {T("Filter")}
              </span>
            </div>
          </div>
        </MobileContainer>

        <DesktopContainer>
          <Form ref={form} className="mt-[34px] lg:mt-[12px] lg:mb-[20px]">
            <FilterRow>
              <FilterRowItem>
                <FormItem label={T("Time")}>
                  <FormSelect
                    allowClear={false}
                    value={queryTabValue?.date}
                    onSelect={(value) => {
                      switch (value) {
                        case "customized":
                          setDatePicker(true);
                          break;
                        default:
                          break;
                      }
                    }}
                    onChange={handleChangeTime}
                  >
                    <FormSelect.Option value={null}>
                      {T("All")}
                    </FormSelect.Option>
                    <FormSelect.Option value={"7days"}>
                      {T("Last 7 days")}
                    </FormSelect.Option>
                    <FormSelect.Option value={"30days"}>
                      {T("Last 30 days")}
                    </FormSelect.Option>
                    <FormSelect.Option value={"60days"}>
                      {T("Last 60 days")}
                    </FormSelect.Option>
                    <FormSelect.Option value={"customized"}>
                      {query[fieldTabName].date === "customized"
                        ? `${moment(query[fieldTabName].fromDate).format(
                            "DD/MM/YYYY"
                          )} - ${moment(query[fieldTabName].toDate).format(
                            "DD/MM/YYYY"
                          )}`
                        : T("Customized")}
                    </FormSelect.Option>
                  </FormSelect>
                </FormItem>
              </FilterRowItem>
              <>
                {false ? (
                  <>
                    <FilterRowItem>
                      <FormItem label={T("Type")}>
                        <FormSelect
                          allowClear={false}
                          value={queryTabValue?.transactionType ?? ""}
                          onChange={(value) =>
                            setQuery(
                              produce((draft) => {
                                draft[fieldTabName].transactionType = value;
                              })
                            )
                          }
                        >
                          {typeTransactionOptions(tab, user.country_code).map(
                            (type, index) => (
                              <FormSelect.Option
                                key={index.toString()}
                                value={type.value}
                              >
                                {T(type.label)}
                              </FormSelect.Option>
                            )
                          )}
                        </FormSelect>
                      </FormItem>
                    </FilterRowItem>
                    <FilterRowItem>
                      <FormItem label={T("Status")}>
                        <FormSelect
                          allowClear={false}
                          value={queryTabValue?.transactionStatus}
                          onChange={(value) =>
                            setQuery(
                              produce((draft) => {
                                draft[fieldTabName].transactionStatus = value;
                              })
                            )
                          }
                        >
                          <FormSelect.Option value={null}>
                            {T("All")}
                          </FormSelect.Option>
                          {tab === "crypto" || tab === "option"
                            ? statusFilterTransaction1.map((status) => (
                                <FormSelect.Option value={status.value}>
                                  {T(status.label)}
                                </FormSelect.Option>
                              ))
                            : statusFilterTransaction2.map((status) => (
                                <FormSelect.Option value={status.value}>
                                  {T(status.label)}
                                </FormSelect.Option>
                              ))}
                        </FormSelect>
                      </FormItem>
                    </FilterRowItem>
                    <FilterRowItem>
                      <FormItem label={T("Transaction ID")}>
                        <FormInput
                          value={queryTabValue?.transactionId}
                          onChange={(value) =>
                            setQuery(
                              produce((draft) => {
                                draft[fieldTabName].transactionId =
                                  value.target.value;
                              })
                            )
                          }
                          placeholder={T("Please enter Transaction ID")}
                        />
                      </FormItem>
                    </FilterRowItem>
                  </>
                ) : (
                  <>
                    <FilterRowItem>
                      <FormItem label={T("From Currency")}>
                        <FormSelect
                          allowClear={false}
                          value={queryTabValue?.fromCurrencyCode}
                          onChange={(value) =>
                            setQuery(
                              produce((draft) => {
                                draft[fieldTabName].fromCurrencyCode = value;
                              })
                            )
                          }
                        >
                          <FormSelect.Option value={null}>
                            {T("All")}
                          </FormSelect.Option>
                          {currencies.map((item, index) => {
                            return (
                              <FormSelect.Option
                                key={index.toString()}
                                value={item.code}
                              >{`${T(item.name)} (${
                                item.code
                              })`}</FormSelect.Option>
                            );
                          })}
                        </FormSelect>
                      </FormItem>
                    </FilterRowItem>
                    <FilterRowItem>
                      <FormItem label={T("To Currency")}>
                        <FormSelect
                          allowClear={false}
                          value={queryTabValue?.currencyCode}
                          onChange={(value) =>
                            setQuery(
                              produce((draft) => {
                                draft[fieldTabName].currencyCode = value;
                              })
                            )
                          }
                        >
                          <FormSelect.Option value={null}>
                            {T("All")}
                          </FormSelect.Option>

                          {currencies.map((item, index) => {
                            return (
                              <FormSelect.Option
                                key={index.toString()}
                                value={item.code}
                              >{`${T(item.name)} (${
                                item.code
                              })`}</FormSelect.Option>
                            );
                          })}
                        </FormSelect>
                      </FormItem>
                    </FilterRowItem>
                    <FilterRowItem>
                      <FormItem label={T("Status")}>
                        <FormSelect
                          allowClear={false}
                          value={queryTabValue?.transactionStatus}
                          onChange={(value) =>
                            setQuery(
                              produce((draft) => {
                                draft[fieldTabName].transactionStatus = value;
                              })
                            )
                          }
                        >
                          <FormSelect.Option value={null}>
                            {T("All")}
                          </FormSelect.Option>
                          {tab === "crypto"
                            ? statusFilterTransaction1.map((status) => (
                                <FormSelect.Option value={status.value}>
                                  {T(status.label)}
                                </FormSelect.Option>
                              ))
                            : statusFilterTransaction2.map((status) => (
                                <FormSelect.Option value={status.value}>
                                  {T(status.label)}
                                </FormSelect.Option>
                              ))}
                        </FormSelect>
                      </FormItem>
                    </FilterRowItem>
                  </>
                )}
              </>
            </FilterRow>
            <DesktopContainer>
              <FilterRow2>
                <>
                  <FilterRowItem className="mr-20">
                    <FormItem label={T("Transaction ID")}>
                      <FormInput
                        value={queryTabValue?.transactionId}
                        onChange={(value) =>
                          setQuery(
                            produce((draft) => {
                              draft[fieldTabName].transactionId =
                                value.target.value;
                            })
                          )
                        }
                        placeholder={T("Please enter Transaction ID")}
                      />
                    </FormItem>
                  </FilterRowItem>
                  {/* <FilterRowItem>
                  </FilterRowItem> */}
                  {/* <FilterRowItem></FilterRowItem> */}
                </>
                {/* {tab === TYPE_WALLET_DETAIL.CRYPTO ||
                tab === TYPE_WALLET_DETAIL.OPTION ? (
                  <>
                    <FilterRowItem>
                      <FormItem label={T("From Address")}>
                        <FormInput
                          value={queryTabValue?.fromAddress}
                          onChange={(value) =>
                            setQuery(
                              produce((draft) => {
                                draft[fieldTabName].fromAddress =
                                  value.target.value;
                              })
                            )
                          }
                          placeholder={T("Please enter sender’s address")}
                        />
                      </FormItem>
                    </FilterRowItem>

                    <FilterRowItem>
                      <FormItem label={T("To Address")}>
                        <FormInput
                          value={queryTabValue?.destAddress}
                          onChange={(value) =>
                            setQuery(
                              produce((draft) => {
                                draft[fieldTabName].destAddress =
                                  value.target.value;
                              })
                            )
                          }
                          placeholder={T("Please enter recipient’s address")}
                        />
                      </FormItem>
                    </FilterRowItem>
                    <FilterRowItem></FilterRowItem>
                  </>
                ) : null} */}

                <FilterRowItem2>
                  <ContainerRow style={{ justifyContent: "flex-end" }}>
                    <FormButton2
                      onClick={() => handleExport()}
                      className="black2"
                      height={52}
                      style={{
                        minWidth: 144,
                        width: language === "ja" ? "auto" : "100%",
                      }}
                    >
                      {T("Export")}
                    </FormButton2>
                    <ContainerRow style={{ width: 10 }} />
                    <FormButton2
                      style={{ width: "50%" }}
                      className="black2"
                      height={52}
                      width={144}
                      onClick={handleReset}
                    >
                      {T("Reset")}
                    </FormButton2>
                    <ContainerRow style={{ width: 10 }} />
                    <FormButton
                      onClick={() => onSearch()}
                      style={{
                        minWidth: 144,
                        width: language === "ja" ? "auto" : "100%",
                      }}
                    >
                      {T("Search")}
                    </FormButton>
                  </ContainerRow>
                </FilterRowItem2>
              </FilterRow2>
            </DesktopContainer>
          </Form>
        </DesktopContainer>
        <>
          <DesktopContainer>
            <ContainerTable>
              <TableView
                locale={{ emptyText: <EmptyTable T={T} /> }}
                scroll={{ x: true }}
                pagination={false}
                dataSource={values}
                columns={columns}
                onChange={handleTableChange}
              />
            </ContainerTable>
          </DesktopContainer>
          <MobileContainer>{renderItemMobile()}</MobileContainer>
        </>
        {total / 15 > 1 ? (
          <PaginationView
            current={page}
            pageSize={15}
            onChange={(p, ps) => {
              setPage(p);
            }}
            total={total}
            itemRender={paginationRender}
          />
        ) : null}
      </div>

      {row ? (
        <Detail
          id={row.id}
          type={tab}
          onClose={(event) => {
            setRow(null);
            setAlert(event);
            loadData();
          }}
        />
      ) : null}

      {alert === "success" ? (
        <Alert>
          <AlertBg />
          <AlertContent>
            <SuccessIcon />
            <AlertText style={{ color: "#4D67C1" }}>
              {T("Your withdrawal request has been canceled")}
            </AlertText>
          </AlertContent>
        </Alert>
      ) : null}
      {alert === "error" ? (
        <Alert>
          <AlertBg />
          <AlertContent>
            <ErrorIcon />
            <AlertText style={{ color: "#E01B1B" }}>
              {T(
                "Failed to cancel your withdrawal request. Please try again later or contact customer support."
              )}
            </AlertText>
          </AlertContent>
        </Alert>
      ) : null}

      {datePicker ? (
        <DatePickerView
          fromDate={query[fieldTabName].fromDate}
          toDate={query[fieldTabName].toDate}
          onCancel={() => {
            setDatePicker(false);
          }}
          onChange={(event) => {
            setQuery(
              produce((draft) => {
                draft[fieldTabName].date = "customized";
                draft[fieldTabName].fromDate = event.fromDate
                  .startOf("day")
                  .toDate()
                  .getTime();
                draft[fieldTabName].toDate = event.toDate
                  .endOf("day")
                  .toDate()
                  .getTime();
              })
            );
            setDatePicker(false);
          }}
        />
      ) : null}
      {isOpenModalFilter && (
        <ModalFilter
          setDatePicker={setDatePicker}
          handleChangeTime={handleChangeTime}
          queryTabValue={queryTabValue}
          fieldTabName={fieldTabName}
          onSearch={onSearch}
          onReset={handleReset}
          setQuery={setQuery}
          tab={tab}
          onClose={toggleModalFilter}
        />
      )}
    </div>
  );
}
